import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { CommonProperties, CommonStyles, Color } from '../../styles';
import BaseText from '../BaseText';
import RowView from '../RowView';
import Icon from '../Icon';
import { scale } from '../../utils/scale.utils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

const CoverSlide = ({ name, startDate }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('TripHubScreen');
  const tripStart = moment(startDate);
  const diff = tripStart.diff(new Date(), 'days');

  return (
    <View style={styles.picture}>
      <RowView style={styles.content}>
        <View style={CommonStyles.flex1} />
        <View style={styles.centerContent}>
          {diff >= 0 ? (
            <View style={styles.circle}>
              {diff > 1 ? (
                <>
                  <BaseText style={styles.circleText}>{t(tKey('In'))}</BaseText>
                  <BaseText style={[styles.circleText, styles.number]}>{diff}</BaseText>
                </>
              ) : null}
              <BaseText style={[styles.circleText, diff > 1 ? null : styles.text]}>
                {diff > 0 ? t(tKey('Days')) : t(tKey('Today'))}
              </BaseText>
            </View>
          ) : (
            <View style={styles.circle}>
              <BaseText style={styles.circleText}>{name}</BaseText>
            </View>
          )}
        </View>
        <TouchableOpacity
          style={{ alignItems: 'flex-end', flex: 1 }}
          onPress={() => {
            //TODO: Add press function to go to the next slide or swipe
          }}
        >
          <Icon style={styles.chevronRight} name="chevronRight" />
        </TouchableOpacity>
      </RowView>
    </View>
  );
};

const styles = StyleSheet.create({
  picture: {
    height: scale(200),
  },
  content: {
    flex: 1,
    alignItems: 'center',
    ...StyleSheet.absoluteFillObject,
    ...CommonProperties.m3,
  },
  centerContent: {
    ...CommonProperties.centerAlignment,
    alignSelf: 'center',
    flex: 2,
  },
  circle: {
    height: scale(100),
    width: scale(100),
    borderRadius: scale(50),
    backgroundColor: 'white',
    ...CommonProperties.centerAlignment,
    ...CommonProperties.my2,
  },
  circleText: {
    color: Color.primary,
    textAlign: 'center',
    ...CommonProperties.h3,
  },
  number: {
    fontSize: scale(30),
    marginTop: -8,
    marginBottom: -8,
  },
  chevronRight: {
    color: Color.accent,
    fontSize: scale(28),
  },
  text: {
    ...CommonProperties.h3,
  },
});

export default CoverSlide;
